import {
  Box,
  FormLabel,
  Grid,
  Stack,
  Typography,
  } from "@mui/material"
import React from "react"

const UserProfile = ({user}) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h6" sx={{ letterSpacing: 2 }} color="primary">
        PERSONAL DETAILS
      </Typography>
      <Stack spacing={1} sx={{ mt: 2 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4}>
            <Stack style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
              <FormLabel>Name</FormLabel>
              {user?.name}
            </Stack>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Stack style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
              <FormLabel>Email</FormLabel>
              {user?.email}
            </Stack>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Stack style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
              <FormLabel>Phone</FormLabel>
              {user?.phone_number}
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  )
}
  
export default UserProfile